import { Login } from "@/features/Auth/Login";
import { sanitizeRedirect } from "@/lib/redirect";
import { createFileRoute } from "@tanstack/react-router";

interface LoginSearchParams {
  redirect?: string;
}

export const Route = createFileRoute("/login")({
  component: Login,
  validateSearch: (search: Record<string, unknown>): LoginSearchParams => ({
    redirect: sanitizeRedirect(search.redirect),
  }),
});
